var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFgdTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.15.5H5.27C3.03.5 1.21 2.32 1.21 4.56v12.88c0 2.24 1.821 4.06 4.06 4.06h12.88c2.24 0 4.06-1.82 4.06-4.06V4.56c0-2.24-1.82-4.06-4.06-4.06zm3.36 16.94a3.376 3.376 0 01-3.36 3.36H5.27a3.376 3.376 0 01-3.36-3.36V4.56A3.376 3.376 0 015.27 1.2h12.88a3.376 3.376 0 013.36 3.36v12.88z",
    fill: "#292929",
    stroke: "#292929",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.331 7.22a.364.364 0 00-.303-.187.364.364 0 00-.304.187l-1.283 2.24a4.667 4.667 0 00-2.17-.537c-.093 0-.187 0-.28.024V5.563a.359.359 0 00-.35-.35h-7.42a.359.359 0 00-.35.35v7.42c0 .187.163.35.35.35h3.383c0 .094-.023.187-.023.28 0 2.59 2.1 4.69 4.69 4.69 2.217 0 4.13-1.586 4.573-3.733h3.104c.116 0 .233-.07.303-.187a.318.318 0 000-.35l-3.92-6.813zm-11.76 5.413v-6.72h6.72V9.04c-1.796.373-3.22 1.797-3.617 3.617H4.571v-.024zm7.7 4.947a4.003 4.003 0 01-3.99-3.99c0-2.193 1.797-3.967 3.99-3.967.63 0 1.26.14 1.82.444l-2.286 3.966a.318.318 0 000 .35c.07.117.186.187.303.187h4.037a4 4 0 01-3.874 3.01h0zm.42-3.733l3.313-5.764 3.337 5.764h-6.65z",
    fill: "#292929",
    stroke: "#292929",
    strokeWidth: 0.75
  })));
}
export default SvgIconFgdTab;